import React from 'react';
import { motion } from 'framer-motion';
import { experience } from '../data/mock';
import { fadeInUp, staggerContainer } from '../lib/animations';

const Experience = () => {
  return (
    <section id="experience" className="relative py-32 bg-gradient-to-b from-[#0a0a0a] via-[#0f0f10] to-[#0a0a0a]">
      <div className="relative max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-20"
        >
          <h2 className="text-5xl sm:text-6xl font-bold mb-6">
            <span className="bg-gradient-to-r from-white to-cyan-400 bg-clip-text text-transparent">
              Development Workflow
            </span>
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            From concept to deployment, a proven process for quality results
          </p>
        </motion.div>

        {/* Timeline */}
        <motion.div
          variants={staggerContainer}
          initial="initial"
          whileInView="animate"
          viewport={{ once: true, margin: "-100px" }}
          className="relative"
        >
          {/* Connecting line */}
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-cyan-500/50 via-cyan-500/30 to-cyan-500/50" />

          <div className="space-y-16">
            {experience.map((item, index) => (
              <motion.div
                key={item.id}
                variants={fadeInUp}
                className={`relative flex items-center gap-8 ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}
              >
                {/* Content Card */}
                <div className="flex-1">
                  <motion.div
                    whileHover={{ scale: 1.02, x: index % 2 === 0 ? 5 : -5 }}
                    className="p-8 bg-gradient-to-br from-white/5 to-white/[0.02] rounded-2xl border border-white/10 hover:border-cyan-500/50 transition-all duration-300"
                  >
                    <div className="flex items-start gap-6">
                      {/* Step number */}
                      <div className="flex-shrink-0 w-16 h-16 bg-gradient-to-br from-cyan-500/20 to-blue-500/20 rounded-xl flex items-center justify-center border border-cyan-500/30">
                        <span className="text-2xl font-bold text-cyan-400">
                          {item.step}
                        </span>
                      </div>
                      
                      <div className="flex-1">
                        <h3 className="text-2xl font-bold text-white mb-3">
                          {item.title}
                        </h3>
                        <p className="text-gray-400 leading-relaxed">
                          {item.description}
                        </p>
                      </div>
                    </div>
                  </motion.div>
                </div>

                {/* Center dot */}
                <div className="hidden md:block flex-shrink-0 w-4 h-4 bg-cyan-500 rounded-full border-4 border-[#0f0f10] shadow-[0_0_20px_rgba(6,182,212,0.5)] z-10" />

                {/* Spacer for alternating layout */}
                <div className="hidden md:block flex-1" />
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Experience;